/* eslint-disable react-hooks/exhaustive-deps */
import ScoreCardHeader from "../Views/ScoreCardHeader";
import "./ScoreCardReadinessScreen.css";
import letsDoItIcon from "../../../assets/images/lets-do-it-icon.svg";
import filledStar from "../../../assets/images/membership-orange-star.svg";
import { useLocation, useNavigate } from "react-router-dom";
import ROUTE_PATHS from "utils/routePaths";
import useWSMApi from "services/api/useWSMApi";
import { useQuery } from "@tanstack/react-query";
import dfwVisionariesGif from "../../../assets/gif/dfw-icons/dfw-Visionaries.gif";
import dfwFreeGif from "../../../assets/gif/dfw-icons/dfw-Free.gif";
import dfwOptimistsGif from "../../../assets/gif/dfw-icons/dfw-Optimists.gif";
import dfwClubGif from "../../../assets/gif/dfw-icons/dfw-Club.gif";
import dfwCreatorsGif from "../../../assets/gif/dfw-icons/dfw-Creators.gif";
import dfwRuleBreakersGif from "../../../assets/gif/dfw-icons/dfw-Rule-breakers.gif";
import dfwInnovatorsGif from "../../../assets/gif/dfw-icons/dfw-Innovators.gif";
import dfwMavericksGif from "../../../assets/gif/dfw-icons/dfw-Mavericks.gif";
import dfwDreamersGif from "../../../assets/gif/dfw-icons/dfw-Dreamers.gif";
import dfwTeamGif from "../../../assets/gif/dfw-icons/dfw-Team.gif";
import dfwThinkersGif from "../../../assets/gif/dfw-icons/dfw-Thinkers.gif";
import dfwExplorerGif from "../../../assets/gif/dfw-icons/dfw-Explorer.gif";
import dfwWellnessGif from "../../../assets/gif/dfw-icons/dfw-Welness-Area.gif";

// Map persona type to DFW icon assets
const PERSONA_ICON_MAP: Record<string, string> = {
  Visionary: dfwVisionariesGif,
  Visionaries: dfwVisionariesGif,
  "Free Soul": dfwFreeGif,
  Optimists: dfwOptimistsGif,
  "Connectors Foundry Club": dfwClubGif,
  Connectors: dfwClubGif,
  Creators: dfwCreatorsGif,
  "Rule-breakers": dfwRuleBreakersGif,
  Innovators: dfwInnovatorsGif,
  Mavericks: dfwMavericksGif,
  Dreamers: dfwDreamersGif,
  Builders: dfwTeamGif,
  Thinkers: dfwThinkersGif,
  Explorers: dfwExplorerGif,
  Wellness: dfwWellnessGif,
};

const DEFAULT_ICON = dfwVisionariesGif;

const getPersonaIcon = (personaType?: string): string => {
  if (!personaType) return DEFAULT_ICON;
  const exact = PERSONA_ICON_MAP[personaType];
  if (exact) return exact;
  const key = Object.keys(PERSONA_ICON_MAP).find((k) =>
    personaType.toLowerCase().includes(k.toLowerCase()),
  );
  return key ? PERSONA_ICON_MAP[key] : DEFAULT_ICON;
};

const ScoreCardReadinessScreen = () => {
  const navigate = useNavigate();
  const { state } = useLocation() as {
    state?: { hasScoreCards: boolean };
  };
  const { fetchUserScoreCardResult } = useWSMApi();

  const { data: scoreCardResult, isLoading } = useQuery({
    queryKey: ["get-user-score-card-result-readiness"],
    queryFn: () => fetchUserScoreCardResult(),
    retry: false,
  });

  const handleCheckResultClick = () => {
    navigate(ROUTE_PATHS.WSM_SCORE_CARD_RESULT_SCREEN, {
      state: {
        hasScoreCards: state?.hasScoreCards ?? false,
      },
    });
  };

  const persona = scoreCardResult?.data?.persona;
  const readiness = scoreCardResult?.data?.readiness;

  // Backend returns title as "The Visionaries" — strip "The " for icon lookup only
  const personaTitle: string = persona?.title ?? "";
  const personaTitleStripped = persona?.type ?? "";
  const personaSubTitle: string = persona?.description ?? "";
  const bottleneck: string = persona?.bottleneck ?? "";
  const whyHappens: string = persona?.whyThisHappens ?? "";
  const underStrain: string = readiness?.systemUnderStrain ?? "";

  const cardImage = getPersonaIcon(personaTitleStripped);

  if (isLoading) {
    return (
      <div className="wms-mobile-container" style={{ background: "#1c1c1e" }} />
    );
  }

  return (
    <div className="wms-mobile-container">
      <div className="score-card-readiness-screen-container">
        <div className="score-card-readiness-screen-header-sticky">
          <ScoreCardHeader
            title="CARD"
            subTitle="PERSONA"
            orangeFirst={true}
            showBackButton={state?.hasScoreCards ?? false}
          />
        </div>
        <div className="score-card-readiness-screen-content-container">
          <div className="main-card">
            <img src={cardImage} alt="score-card-image" />
            <span className="card-title">
              <span style={{ color: "#FF6B35" }}>{personaTitle}</span>
            </span>
            <span className="card-sub-title">{personaSubTitle}</span>
            <div className="details-container">
              <div className="header">
                <span>
                  UR <span style={{ color: "white" }}>Bottleneck</span>
                </span>
              </div>
              <div className="details">
                <img src={filledStar} alt="star-image" />
                <span>{bottleneck}</span>
              </div>
            </div>
            <div className="details-container">
              <div className="header">
                <span>
                  WHY <span style={{ color: "white" }}>THIS HAPPENS?</span>
                </span>
              </div>
              <div className="details">
                <img src={filledStar} alt="star-image" />
                <span>{whyHappens}</span>
              </div>
            </div>
            <div className="details-container">
              <div className="header">
                <span>
                  UR SYSTEM IS{" "}
                  <span style={{ color: "white" }}>UNDER STRAIN?</span>
                </span>
              </div>
              <div className="details">
                <img src={filledStar} alt="star-image" />
                <span>{underStrain}</span>
              </div>
            </div>
          </div>
          <div className="button-container" onClick={handleCheckResultClick}>
            <>
              <span>
                Check Ur{" "}
                <span style={{ color: "#FF6B35" }}>Readiness Scorecard</span>
              </span>
              <img src={letsDoItIcon} alt="right-arrow-icon" />
            </>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScoreCardReadinessScreen;
